import React, { useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import LeftArrow from "../assets/images/left-arrow.svg";
import Facebook from '../assets/images/facebook-2.svg'
import X from '../assets/images/x-2.svg'
import LinkedIn from '../assets/images/linkedin.svg'
function HelpDetail() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(
    "portable-applications-faqs"
  );

  const sidebarLinks = [
    {
      id: "portable-applications-faqs",
      label: "Portable Applications FAQs",
      active: true,
    },
    { id: "moving-questions", label: "Moving Questions" },
    { id: "set-up-payment", label: "Set up A Payment" },
    { id: "screening-reports", label: "Screening Reports" },
    { id: "combined-appscreenfaq", label: "Combined App/Screen/FAQ" },
  ];
  const faqContent = [
    {
      question: "What you'll learn in this article:",
      answers: [
        "What is a portable tenant screening report?",
        "What does it mean that the Real Estate application is “portable”?",
        "A renter said they applied. When will I receive their application?",
        "My state/city/county has specific rules about rental applications–is the Real Estate application compliant?",
        "What does it mean to enable or accept applications for my properties?",
      ],
    },
    {
      question: "What is a portable tenant screening report? ",
      answer:[
        "A: Portable tenant screening reports (PTSR) are credit and background checks obtained by renters that are typically valid for 30 days and can be shared with multiple landlords. This alleviates the need for each landlord to perform their own credit and background check, which often comes at a cost to renters. Some states have laws that allow or require landlords to accept PTSRs. Typically, if a landlord accepts a PTSR, they cannot charge the renter an application fee.",
        "The Real Estate application includes credit and background checks that, where accepted, can be used both on and off the Real Estate platform."
      ],
    },
    {
      question:
        'What does it mean that the Real Estate application is “portable”?',
      answer:[
        "A: It means a renter who purchases a Real Estate application can reuse their application to apply to unlimited properties both on and off Real Estate for 30 days. Real Estate applications include credit and background reports.",
        "Landlords can use these reports separately from the application. You will still need to verify your identity to view this sensitive applicant information."
      ],
    },
    {
      question:
        "A Renter Can They Applied, When Will I Receive Their Application?",
      answer:
        "If you already have a third-party tenant listings account, When applications are completed they will be available immediately in your account at the property for which the listing was placed. Report your username or password on your listing or use your password and renew application at your applicant when the application is needed for other properties. Then after your successfully applied.",
    },
    {
      question:
        "A renter said they applied. When will I receive their application?",
      answer: [
        "If you already have a Real Estate Rental Manager account: When applications are completed, they will be available immediately in your account under your listing in Real Estate Rental Manager. Select your rental listing and under the Applications tab select the application you would like to view or select 'View more' to view all submitted applications. You will also be notified via email as soon as the application is submitted.",
        "If a renter has told you that they have paid their screening fee and completed their application, but you do not see the application in your account, it means the renter has not clicked the Submit button to send the application to you. While we understand that the renter may have already paid for the application and received the payment confirmation, they must still click on the Submit button to send the application to your account.",
        "If they have reached out to you regarding their application, please refer them to their Renter Hub to double-check that they have submitted their application.",
        "If you don’t yet have a Real Estate Rental Manager account, you’ll receive a preview of the application via email. In that email, you’ll be directed to view the rental application in Real Estate Rental Manager, where you’ll be asked to create an account and verify your identity to view the whole application, including any credit or background reports. "
      ]
    },
    {
      question:
        "What does it mean to enable or accept applications for my properties?",
      answer:[
        "A: If you have enabled applications on your properties, all renters will see an Apply now button on your listing on Real Estate, Trulia and HotPads, and they can apply directly from your listing.",
        "If you have not enabled applications, you can still invite specific renters to apply. Simply go to the Applications tab in Real Estate Rental Manager, click Send invite, and enter the interested renter’s email address.",
        "Renters who have already purchased an application can also share their application directly with you, as long as you provide them with an email. Their application will appear within Real Estate Rental Manager once it is submitted."
      ]
    },
  ];

  const relatedArticles = [
    "General Questions",
    "Screening Reports",
    "Set up & Payment",
    "Real Estate Customer Support Form",
    "Portable Applications FAQs"
  ];
  return (
    <>
      <div className="main help-page help-detail-page">
        <Header />
        <section className="help-list-section help-detail-section common-padding">
          <Container>
            <div className="help-header">
              <button
                className="back-button detail-btn"
                onClick={() => navigate(-1)}
              >
                <img src={LeftArrow} alt="Back" />
              </button>
              <div className="header-content">
                <p className="subtitle">Back to list</p>
              </div>
            </div>
            <Row>
              <Col lg={3} md={4} className="sidebar-col">
                <div className="help-sidebar">
                  <h5 className="sidebar-title">Articles in This Section</h5>
                  <ul className="sidebar-links">
                    {sidebarLinks.map((link, index) => (
                      <li
                        key={index}
                        className={activeSection === link.id ? "active" : ""}
                      >
                        <Link
                          to={`#${link.id}`}
                          onClick={() => setActiveSection(link.id)}
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>

              {/* Main Content */}
              <Col lg={9} md={8}>
                <div className="help-content">
                  {/* Page Title */}
                  <div className="content-header">
                    <h1>Portable Applications FAQs</h1>
                    <div className="meta-info">
                      <span className="updated">7 months ago Updated</span>
                    </div>
                  </div>

                  {/* FAQ Content */}
                  <div className="faq-content">
                    {faqContent.map((faq, index) => (
                      <div className="faq-block" key={index}>
                        <h3 className="faq-question">{faq.question}</h3>
                        {faq.answers ? (
                          <ul className="faq-list">
                            {faq.answers.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        )  : Array.isArray(faq.answer) ? (
                          faq.answer.map((paragraph, i) => (
                            <p className="faq-answer" key={i}>{paragraph}</p>
                          ))
                        ) : (
                          <p className="faq-answer">{faq.answer}</p>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Social Share */}
                  <div className="share-section" title="Facebook">
                     <a href="#" target="_blank">
                      <img src={Facebook} alt="Facebook" />
                    </a>
                     <a href="#" target="_blank" title="Twitter">
                      <img src={X} alt="Twitter" />
                    </a>
                     <a href="#" target="_blank" title="LinkedIn">
                      <img src={LinkedIn} alt="LinkedIn" />
                    </a>
                  </div>

                  {/* Related Articles */}
                  <div className="related-articles">
                    <h4>Related Articles</h4>
                    <ul>
                      {relatedArticles.map((article, index) => (
                        <li key={index}>
                          <Link to="#">{article}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  );
}
export default HelpDetail;
